import Echo from "laravel-echo";
import Pusher from "pusher-js";

window.Pusher = Pusher;

const echo = new Echo({
  broadcaster: "pusher",
  key: '86042125318ef878a53f',
  cluster: 'mt1',
  forceTLS: false, // 🔥 IMPORTANT
  enabledTransports: ["ws", "wss"],
});

export default echo;
                      